import request from '@/axios'

// 绑定私信渠道获取二维码
// type 1:dingtalk 2:wechat 3:wecom 4:feishu
export function getChannelsQrcode(data) {
  return request({
    url: '/api/qca/channels/qrcode',
    data
  })
}

// 私信推送渠道列表
export function getChannelsList() {
  return request({
    url: '/api/qca/channels/list'
  })
}

// 群聊推送渠道列表
export function getGroupChannelsList() {
  return request({
    url: '/api/qca/channels/group/list'
  })
}

// 新增群聊推送渠道
// channelType 1:钉钉 3:企微 4:飞书
export function createChannels(data) {
  return request({
    url: '/api/qca/channels/create',
    data
  })
}

// 轮询扫码会话状态，入参 sessionKey
export function getScanSessionStatus(data) {
  return request({
    url: '/api/qca/channels/scanSession/status',
    data
  })
}

// 二维码过期后刷新扫码会话，入参 channelId
export function refreshScanSession(data) {
  return request({
    url: '/api/qca/channels/scanSession/refresh',
    data
  })
}

// 删除渠道前检查，入参 id（渠道实例 id）
export function deleteCheckChannels(data) {
  return request({
    url: '/api/qca/channels/delete/check',
    data
  })
}

// 删除渠道，入参 id（渠道实例 id）
export function deleteChannels(data) {
  return request({
    url: '/api/qca/channels/delete',
    data
  })
}

// 绑定外部 id，入参 channelId、text
export function bindExternalId(data) {
  return request({
    url: '/api/qca/channels/externalId/bind',
    data
  })
}
